import ApiRequest from 'core-api';
import { API_URL } from 'src/enums/apiPath';
import { logout } from 'src/services/auth';

export const apiRequest = new ApiRequest({
  baseUrl: API_URL,
  onUnauthenticated: () => logout()
});
export const apiRequestCompanyRegistration = new ApiRequest({
  baseUrl: API_URL,
});